module.exports = __webpack_public_path__ + "media/images/services/storage-6e8070d7eae2aa925724fba00a94cce9.jpg";